import React, { useMemo } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { useCurrency } from '@oolio-group/localization';
import { useCartNavigationHelper } from '../../../hooks/useCartNavigationHelper/useCartNavigationHelper';
import { getStyles } from './PaymentConfirmation.styles';
import { useTheme } from '../../../hooks/useTheme';
import IconStatus from '../../../component/Icon/IconStatus';
import { Media } from '../../../component/Media/Media';
import useBehaviorSubjectState from '../../../hooks/rxjs/useSubjectState';
import { sessionSubject } from '../../../state/sessionObservable';
import { resolveBrandColor } from '../../../utils/branding';

interface Props {
  amount?: number;
  changeDue?: number;
}

const PaymentConfirmation: React.FC<Props> = ({
  amount = 0,
  changeDue = 0,
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);
  const { formatCurrency } = useCurrency();
  const { navigateSendReceiptScreen } = useCartNavigationHelper();
  const { value: session } = useBehaviorSubjectState(sessionSubject);

  const display = session?.device?.deviceProfile?.customerDisplay;
  const config = display?.idleScreen;

  return (
    <View
      style={[
        styles.container,
        { backgroundColor: resolveBrandColor(display?.brandColor) },
      ]}
    >
      <Media config={config} />
      <View style={styles.content}>
        <View style={styles.lhs}>
          <View style={styles.header}>
            <IconStatus name="success" />
            <Text style={styles.title}>Payment Complete!</Text>
          </View>
          <View style={styles.text}>
            <Text style={styles.label}>Total Paid</Text>
            <Text style={styles.amount}>{formatCurrency(amount)}</Text>
            {changeDue !== 0 && (
              <Text style={styles.label}>{`Change Due: ${formatCurrency(
                changeDue,
              )}`}</Text>
            )}
          </View>
          <TouchableOpacity
            testID="sendReceiptBtn"
            style={styles.btn}
            onPress={navigateSendReceiptScreen}
          >
            <Text style={styles.btnText}>Send Receipt</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default PaymentConfirmation;
